import { vec2 } from '@tlaukkan/tsm';
import * as PIXI from 'pixi.js';
import { ShapePrimative } from "../../../shared/ShapePrimative";

type PixiShapeType = PIXI.Circle | PIXI.Rectangle | PIXI.Polygon;

export function createShapePrimative(shape: ShapePrimative, radius: number) {
	let pixiShape: PixiShapeType;
	if (shape === ShapePrimative.HEX) {
		const halfRadius = radius / 2;
		pixiShape = new PIXI.Polygon([
			new PIXI.Point(-halfRadius, radius),
			new PIXI.Point(halfRadius, radius),
			new PIXI.Point(radius, 0),
			new PIXI.Point(halfRadius, -radius),
			new PIXI.Point(-halfRadius, -radius),
			new PIXI.Point(-radius, 0),
		]);
	} else if (shape === ShapePrimative.CIRCLE) {
		pixiShape = new PIXI.Circle(0, 0, radius)
	} else if (shape === ShapePrimative.TRIANGLE) {
		const verts = [
			new PIXI.Point(-radius, -radius),
			new PIXI.Point(radius, 0),
			new PIXI.Point(-radius, radius)
		];
		pixiShape = new PIXI.Polygon(verts);
	} else {
		// Square
		const verts = [
			new PIXI.Point(-radius, -radius),
			new PIXI.Point(-radius, radius),
			new PIXI.Point(radius, radius),
			new PIXI.Point(radius, -radius)
		];
		pixiShape = new PIXI.Polygon(verts);
	}
	return pixiShape;
}

export function drawArrow(gfx: PIXI.Graphics, sideLength: number) {
	gfx.beginFill(0x000000, 1)
		.lineStyle(2, 0xffffff)
		.moveTo(0, -sideLength / 2)
		.lineTo(-sideLength / 2, sideLength / 2 + 4)
		.lineTo(sideLength / 2, sideLength / 2 + 4)
		.lineTo(0, -sideLength / 2)
		.endFill();
}

export function drawDottedLine(gfx: PIXI.Graphics, start: vec2, end: vec2, dashLength: number, color: number, alpha = 1) {
	const length = vec2.distance(end, start);
	const step = vec2.direction(start, end).scale(dashLength);
	let drawnLength = 0;
	let pen = start.copy();
	gfx.beginFill(color, 1)
		.lineStyle(8, color, alpha)
		.moveTo(start.x, start.y);
	while (drawnLength < length) {
		pen.subtract(step);
		gfx.lineTo(pen.x, pen.y);
		pen.subtract(step);
		gfx.moveTo(pen.x, pen.y);
		drawnLength += (dashLength * 2);
	}
	gfx.endFill();
}

export function drawCooldownBar(gfx: PIXI.Graphics, x: number, y: number, width: number, height: number, progress: number, fullColor: number, emptyColor: number) {
	gfx.lineStyle(0);
	gfx.beginFill(emptyColor);
	gfx.drawRect(x, y, width, height);
	gfx.endFill();

	gfx.lineStyle(1, 0xbbbbbb);
	gfx.drawRect(x, y - 1, width, height + 1);

	gfx.beginFill(fullColor);
	gfx.drawRect(x, y, width - (width * progress), height);
	gfx.endFill();

	gfx.lineStyle(0);
}

export function drawProgressBar(gfx: PIXI.Graphics, x: number, y: number, width: number, height: number, progress: number, fullColor: number, emptyColor: number) {
	gfx.lineStyle(0);
	gfx.beginFill(emptyColor);
	gfx.drawRect(x, y, width, height);
	gfx.endFill();

	gfx.lineStyle(1, 0xbbbbbb);
	gfx.drawRect(x, y - 1, width, height + 1);

	gfx.beginFill(fullColor);
	gfx.drawRect(x, y, width * progress, height);
	gfx.endFill();

	gfx.lineStyle(0);
}